const RESOURCES_PAGE_TRACKING_KEY = 'resources-page-tracking-key'; // Key for session storage

export const setLatestResourcesUrl = () =>
  window.sessionStorage.setItem(RESOURCES_PAGE_TRACKING_KEY, window.location.href);

export const getLatestResourcesUrl = () => window.sessionStorage.getItem(RESOURCES_PAGE_TRACKING_KEY);
